<div [class]="skinName">
  <div id="select-plan">
    @if (!paymentDialog && paymentDialogStore) {
      <app-signup-step [plans]="allPlans" (emitStep)="getSignStep($event)" [backRoute]="backRoute" [currentStep]="currentStep" [showChangePlan]="false" [hideSteps]="true"></app-signup-step>
    }
    <div [ngClass]="{'payment-title': paymentDialog}">
      <div id="signup-title">{{ configService.localeKeys?.['plans.choose_plan.text'] || 'Choose your plan' }}</div>
      <!-- <div id="signup-title">{{planService.freeTrialText}}</div>
      <div [ngClass]="oldUser ? 'subTitleTopPad' : 'subTitleBotPad'">{{ configService.localeKeys?.['plans.choose_plan.text'] }}</div> -->
      @if (paymentDialog) {
        <div id="select-text">{{ configService.localeKeys?.select_plan_below || 'You may select a plan below.'}}</div>
      }
    </div>
    @if(!avodPlans && !svodPlans){
      <div class="loader">
        <img class="loader-img loader-size" src="branding/theme/assets/static_assets/ic-app-loader.svg" alt="">
    </div>
    }
    @if(avodPlans?.length || svodPlans?.length){
      <div id="select-plan-pad">
        @if (avodPlans?.length) {
          <div id="avod-plan-details" [ngClass]="subscriptions.length == 1? 'single-plan': 'multi-plan'">
            @if (avodPlans?.length && svodPlans?.length) {
              <div class="plan-plantype">
                <p class="plantype-title">{{configService.localeKeys?.['plans_listing.with_ads.text'] || 'With Ads'}}</p>
                <p class="plantype-info">{{configService.localeKeys?.['plans_listing.download_promo_line.text'] || 'Download and watch on the go'}}</p>
              </div>
            }
            @for (plan of avodPlans; track plan; let i = $index) {
              <div id="plan-info" [ngClass]="(plan.isSelected == 1) ? 'selected-plan-border': 'plan-border'" (click)="selectPlan(i, plan, 'avod')">
                <app-card-plan [selectedPopular]="plan.popular_status == 1 ? true : false" [plan]="plan" [selectedPlan]="selectedPlan"></app-card-plan>
              </div>
            }
          </div>
        }
        @if (svodPlans?.length) {
          <div id="svod-plan-details" [ngClass]="subscriptions.length == 1? 'single-plan': 'multi-plan'">
            @if (avodPlans?.length && svodPlans?.length) {
              <div class="plan-plantype">
                <p class="plantype-title">{{configService.localeKeys?.['plans_listing.ads_free.text'] || 'Ads Free'}}</p>
                <p class="plantype-info">{{ configService.localeKeys?.['plans.subscription_plan_tagline.text'] || 'Download and watch on the go'}}</p>
              </div>
            }
            @for (plan of svodPlans; track plan; let i = $index) {
              <div id="plan-info" [ngClass]="(plan.isSelected == 1) ? 'selected-plan-border': 'plan-border'" (click)="selectPlan(i, plan, 'svod')">
                <app-card-plan [selectedPopular]="plan.popular_status == 1 ? true : false" [plan]="plan" [selectedPlan]="selectedPlan"></app-card-plan>
              </div>
            }
          </div>
        }
      </div>
    }
 
    <!-- coupon mapped info display to the selected plan -->
    @if (couponPlan && !selectedPlan?.coupon_mapped && type ==='redeemCoupon') {
      <div class="coupon-failed-info">
        <p>{{configService.localeKeys?.plans_code_invalid_msg_part1 || 'Your coupon code is not valid for the selected package.'}}</p>
        <p>{{configService.localeKeys?.plans_code_invalid_msg_part2 || 'If you conitnue, we will proceed at the regular price.'}}</p>
      </div>
    }
    @if (couponPlan && selectedPlan?.coupon_mapped && type ==='redeemCoupon' && selectedPlan?.coupon_type === 'discount') {
      <div class="coupon-success-info">
        <p>{{configService.localeKeys?.plans_code_amt_to_pay_msg_part1 || 'With your coupon code, the amount you will pay is'}}</p>
        <p>{{selectedPlan?.payable_amount}} {{selectedPlan?.plan_detail}} {{configService.localeKeys?.plans_code_amt_to_pay_msg_part2}}</p>
      </div>
    }
    @if (couponPlan && selectedPlan?.coupon_mapped && type ==='redeemCoupon' && selectedPlan?.coupon_type === 'trial') {
      <div class="coupon-success-info">
        <p>{{configService.localeKeys?.plans_code_trial_days_msg_part1}}</p>
        <p>{{selectedPlan?.free_trial_days}} {{configService.localeKeys?.plans_code_trial_days_msg_part2}} </p>
      </div>
    }
  </div>

  @if (enableFlag) {
    <div class="plan-btn-container">
      <!-- mobile screen sticky button changes -->
      @if (innerWidth && isMobileScreen) {
        <div class="plan-btn-mobile">
          <p class="plantype-mobile">{{configService.localeKeys?.plans_selected_pck_info || 'Your Selected Packages'}}</p>
          @if (couponPlan && selectedPlan?.coupon_mapped && type ==='redeemCoupon' && selectedPlan?.coupon_type === 'discount') {
            <p class="plantype-mobile">{{configService.localeKeys?.plans_code_amt_to_pay_msg_part1 || 'With your coupon code, the amount you will pay is'}}</p>
            <p class="plantype-info">  {{selectedPlan?.payable_amount}} <span class="stricked-price">{{selectedPlan?.original_amount? selectedPlan?.original_amount : '' }}</span> {{ selectedPlan?.plan_detail}}</p>
          }
          @if (couponPlan && !selectedPlan?.coupon_mapped && type ==='redeemCoupon') {
            <p>{{configService.localeKeys?.plans_code_invalid_msg_part1 || 'Your coupon code is not valid for the selected package.'}}</p>
            <p>{{configService.localeKeys?.plans_code_invalid_msg_part2 || 'If you conitnue, we will proceed at the regular price.'}}</p>
          }
          @if (!couponPlan) {
            <p class="plantype-info">{{selectedPlan?.amount? selectedPlan?.amount : '' }} {{ selectedPlan?.plan_detail}}</p>
          }
          <button [disabled]="baseService.disableFormButton" class="btn" type="button" (click)="onPlanSubmit()">{{buttonValue}}</button>
        </div>
      }
      <!-- web responsive button change -->
      @if (innerWidth && !isMobileScreen) {
        <div class="plan-btn-desktop">
          <button [disabled]="baseService.disableFormButton" class="btn" type="button" (click)="onPlanSubmit()">{{buttonValue}}</button>
        </div>
      }
    </div>
  }
</div>